import React, { useState, useEffect } from 'react';
import { firebase } from '../../firebase';
import { Table } from 'reactstrap';
import NavAdmin from './NavAdmin';
const AllWorkers = (props) => {

    const [users, setUsers] = useState([]);

    useEffect(() => {
        fetchUsuarios();
    }, []);

    const fetchUsuarios = async () => {
        try {
            const res = await firebase.firestore().collection('users').get();
            const arrayUsers = res.docs.map(doc => doc.data());
            setUsers(arrayUsers);
        } catch (error) {
            console.log(error);
        }
    };
    //console.log(users);

    const makeWorker = (email) => {
        const addRole = firebase.functions().httpsCallable('addNewWorker');

        addRole({ email: email })
            .then(res => {
                console.log(res);
                if (res.data.error) {
                    console.log('no tienes permisos');
                    return;
                }
                firebase.firestore().collection('users').doc(email).update({ role: 'trabajador' })
                    .then(user => {
                        console.log('usuario ahora es trabajador');
                        fetchUsuarios();
                    });
            });
    };
    return (
        <div>
            <NavAdmin />
            <div className='container'>
                <div className='mt-4 mb-4'>
                    <h3>Datos por socio</h3>
                </div>
                <Table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Rol</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    {
                        users.map(user => (
                            <tbody>
                                <tr>
                                    <td>{
                                        user.role !== 'usuario' ? (<div>{user.name}</div>) : (null)
                                    }</td>
                                    <td>{
                                        user.role !== 'usuario' ? (<div>{user.role}</div>) : (null)
                                    }</td>
                                    <td>{
                                        user.role === 'trabajador' ? (<div onClick={() => console.log('activo')}>Activo</div>)
                                            : (null)
                                    }</td>

                                    <td>{
                                        user.role === 'trabajador' ? (<div>
                                            <span class="material-icons">
                                                get_app
                                            </span></div>)
                                            : (null)
                                    }</td>



                                </tr>
                            </tbody>
                        ))
                    }
                </Table>
            </div>
        </div>
    );
};

export default AllWorkers;
